import { UserState } from './state';
import { MutationTree } from 'vuex';
import Vue from 'vue';
import ApplicationsActions from '../../../models/ApplicationsActions';
import ApplicationsActionsLocale from '../../../models/ApplicationsActionsLocale';

export enum UserMutationTypes {
  SET_INFO = 'SET_INFO',
  SET_APPS = 'SET_APPS',
  SET_LOADED = 'SET_LOADED',
  RESET = 'RESET',
  SET_PROFILE_URL = 'SET_PROFILE_URL',
  SET_LOGOUT_URL = 'SET_LOGOUT_URL',
  SET_LOCALE_ACTIONS = 'SET_LOCALE_ACTIONS',
}

export const mutations: MutationTree<UserState> = {
  [UserMutationTypes.SET_INFO](state, userInfo) {
    state.info = userInfo;
  },
  [UserMutationTypes.SET_PROFILE_URL](state, url) {
    state.profileUrl = url;
  },
  [UserMutationTypes.SET_LOGOUT_URL](state, url) {
    state.logoutUrl = url;
  },
  [UserMutationTypes.SET_LOADED](state) {
    state.loaded = true;
  },
  [UserMutationTypes.SET_APPS](state, allowedApps) {
    Vue.set(state, 'allowedApps', allowedApps);
  },
  [UserMutationTypes.SET_LOCALE_ACTIONS](state, payload) {
    const { locale, application, data } = payload;
    if (!state.applicationsActions[application]) {
      Vue.set(state.applicationsActions, application, new ApplicationsActionsLocale());  
    }
    Vue.set(state.applicationsActions[application], locale, { loaded: true, data });
  },
  [UserMutationTypes.RESET](state) {
    state.loaded = false;
    state.info = undefined;
    Vue.set(state, 'allowedApps', undefined);
  }
};
